/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: search
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 *  Gestion de l'affichage des facettes disponibles en fonction de la configuration de recherche selectionnée pour les pages d'accueil de rubrique.
 */
(function () {

    let selectConf = document.getElementById("RECHERCHE_TYPE_CONFIGURATION");

    if(selectConf) {
        gestionAffichageFacettes(selectConf.value);
        selectConf.onchange = function () {
            gestionAffichageFacettes(selectConf.value);
        };
    }

    function gestionAffichageFacettes(confKeySelected) {
        [].forEach.call(document.querySelectorAll('.multiselect-facettes'), function (el) {
            el.classList.add('masquer');
        });
        let selectsFacettes = document.querySelectorAll(".multiselect-" + confKeySelected);
        if (selectsFacettes && selectsFacettes.length > 0) {
            selectsFacettes[0].classList.remove("masquer");
        }
    }
})();